import React from "react";
import useReveal from "../hooks/useReveal";

export default function Integrations({ content = {} }) {
  const { ref, cls } = useReveal();
  const logos = (content.integration_logos || [])
    .map((it) => (typeof it === "string" ? { image: it, url: "" } : it))
    .filter((it) => it && it.image);
  return (
    <section className="bg-white py-24">
      <div ref={ref} className={`max-w-[1180px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center ${cls}`}>
        <div>
          <h2 className="gp-heading text-[2.3rem] sm:text-[2.7rem]">{content.integ_title || "Integrate with your other software"}</h2>
          <p className="text-[#5a6b80] text-[1.12rem] leading-relaxed mt-5 max-w-[480px]">
            {content.integ_text || "Redeem gift vouchers from your POS, send order data to your CRM and build out your central customer view."}
          </p>
          <a href="#features" className="gp-btn-outline inline-block rounded-full px-8 py-3 font-medium mt-8">
            {content.integ_cta || "Explore integrations"}
          </a>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
          {logos.map((logo, i) => {
            const inner = <img src={logo.image} alt={`Integration ${i + 1}`} className="max-h-10 max-w-full object-contain" />;
            const cardCls = "aspect-square bg-white rounded-2xl border border-gray-100 shadow-[0_8px_24px_rgba(20,30,55,0.06)] flex items-center justify-center p-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_36px_rgba(20,30,55,0.12)]";
            return logo.url ? (
              <a key={i} href={logo.url} target="_blank" rel="noreferrer" className={cardCls} data-testid={`integration-logo-${i}`}>{inner}</a>
            ) : (
              <div key={i} className={cardCls}>{inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
